import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const component: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/05/04/principle/absorption-70-shape-rectangular.svg`,
        },
      },
    },
  },
];
